<tr>
  <td class="number">{{ exerIndex + 1 }}.</td>
  <td class="task_text">
    <ng-katex *ngIf="isKatexFormat(exercise)" class="katex" [equation]="exercise.text"></ng-katex>
    <ng-katex-paragraph *ngIf="!isKatexFormat(exercise)" [paragraph]="exercise.text | exerciseFormat"></ng-katex-paragraph>
  </td>
  <td class="answer">
    <div class="input-group active">
      <span><input
        type="text"
        name=""
        class="text-center"
        [disabled]="!isAuthorCard || !isAccessCard"
        [(ngModel)]="answerStr"
        (ngModelChange)="answerInputChange($event)"
        [class.true]="checkCorrectStyling()"
        [class.false]="!checkCorrectStyling()"
        [class.empty]="isEmptyAnswer()"
      ></span>
      <span *ngIf="isAuthorCard && isAccessCard" class="cross" (click)="clearAnswer($event)">x</span>
    </div>
  </td>
</tr>
